import { apiAuth, apiResponseType } from ".";

export const getConfigTenants = (): apiResponseType =>
  apiAuth.get("configs");

export const showConfigTenant = (uuid: string): apiResponseType =>
  apiAuth.get(`configs/${uuid}/show`);

export const updateConfigTenant = (
  uuid: string,
  data: { value: string }
): apiResponseType =>
  apiAuth.put(`configs/${uuid}/update`, data);

export interface PixConfigResult {
  pixSicrediActive: boolean;
  pixBtgActive: boolean;
}

export const getPixOperatorConfig = async (): Promise<PixConfigResult> => {
  try {
    const { data, ok } = await getConfigTenants();
    if (ok && data?.response) {
      const configs = data.response as Array<{ key: string; value: string }>;
      const pixSicredi = configs.find((c) => c.key === "pix_sicredi");
      const pixBtg = configs.find((c) => c.key === "pix_btg");

      return {
        pixSicrediActive: pixSicredi?.value === "true",
        pixBtgActive: pixBtg?.value === "true",
      };
    }
  } catch (error) {
    console.error("Error fetching PIX config:", error);
  }

  return {
    pixSicrediActive: false,
    pixBtgActive: false,
  };
};
